<template>
    <svg
        class="loader"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        width="20"
        height="20"
        preserveAspectRatio="xMidYMid"
    >
        <circle
            cx="50"
            cy="50"
            r="38"
            fill="none"
            stroke="var(--custom-color-main)"
            stroke-width="8"
            stroke-dasharray="160 80"
            stroke-linecap="round"
            opacity="0.8"
        />
    </svg>
</template>

<style scoped>
.loader {
    display: block;
    animation: loader-spin 0.8s linear infinite;
}

@keyframes loader-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
